const QuoteTypes = {
  SINGLE: 'single',
  BLOCK: 'block',
};

module.exports = QuoteTypes;
